import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from '../base/Icon';
import type { BaseIconProps } from '../types';
const Unknown: React.FC<BaseIconProps> = t0 => {
  const $ = _c(4);
  const {
    size: t1,
    width,
    height
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" fill="#9e9e9e" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== iconHeight || $[2] !== iconWidth) {
    t3 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none">{t2}</Icon>;
    $[1] = iconHeight;
    $[2] = iconWidth;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default Unknown;